import $i from "~/i18n";

export const getBio = async ({ commit }) => {
  try {
    let { data } = await axios.post("/bio/get-my-bio");
    if (data.state !== 200) return;
    if (data.bio.length) {
      commit("SET_DATA", { data: data.bio[0], id: "bio" });
    }
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const saveBio = async ({ commit, dispatch }, payload) => {
  try {
    let body = { ...payload };
    delete body.imgSrc;
    var formData = new FormData();
    for (const key in body) {
      if (key === "img") {
        formData.append(key, body[key], "image.png");
      } else {
        formData.append(key, body[key]);
      }
    }
    let { data } = await axios.post("/bio/save", formData);
    if (data.state !== 200) return;
    dispatch(
      "auth/upsertUser",
      {
        img: data.bio[0].img
      },
      { root: true }
    );
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
    
  }
};
export const updateBio = async ({ commit }, payload) => {
  try {
    let body = { ...payload };
    delete body.img;
    let { data } = await axios.post("/bio/update-text-bio", body);
    if (data.state !== 200) return;
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {}
};
export const setSpecial = async ({ commit }, {url}) => {
  try {
    let { data } = await axios.post("/become-instructor/special", {url});
    if (data.state !== 200) {
      let {error} = data
      error.forEach(element => {
        commit(
          "notifications/error",
          { message: element, title: "" },
          { root: true }
        );
      });
      console.log(data.error)
      return
    };
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {}
};
export const updateAvatar = async (
  { commit, dispatch },
  { fileData, event }
) => {
  try {
    var formData = new FormData();
    formData.append("img", fileData);
    let { data } = await axios.post("/bio/update-img-bio", formData, {
      onUploadProgress: function(progressEvent) {
        commit("SET_DATA", {
          data: parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          ),
          id: "uploadPercentage"
        });
      }
    });
    commit("SET_DATA", { data: 0, id: "uploadPercentage" });
    if (data.state !== 200) {
      if (data.state === 403) {
        commit(
          "notifications/warn",
          { message: "فرمت مجاز نمیباشد ... ", title: "" },
          { root: true }
        );
      }
      if (data.err == 500) {
        commit(
          "notifications/warn",
          { message: "مشکلی پیش آمده است ", title: "" },
          { root: true }
        );
      }
      return;
    }
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    dispatch(
      "auth/upsertUser",
      {
        img: data.img
      },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};

export const updateFullname = async ({ commit, dispatch }, { fullname }) => {
  try {
    let { data } = await axios.post("/users/edit-fullname", { fullname });
    if (data.state !== 200) return;
    dispatch(
      "auth/upsertUser",
      {
        fullname: fullname
      },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};

export const checkInstructorSpecial = async ({ commit }) => {
  try {
    let { data } = await axios.post("/become-instructor/get-instructor");
    console.log(data)
    if (data.state !== 200) return;
    // if (data.bio.length) {
    //   commit("SET_DATA", { data: data.bio[0], id: "bio" });
    // }
    return data;
  } catch (error) {
    console.log(error);
  }
};


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/profile/actions.js